import { defineComponent as _defineComponent } from 'vue';
import { SIcon, STooltip } from '@strana-artw/ui-kit';
import { storeToRefs } from 'pinia';
import { computed, defineComponent, ref, toRefs } from 'vue';
import DowngradeLoyaltyStatus from '@/components/layout/next/parts/Loyalty/DowngradeLoyaltyStatus.vue';
import LoyaltyButton from '@/components/layout/next/parts/Loyalty/LoyaltyButton.vue';
import { useScreenPlugin } from '@/plugins/vue-screen';
import { useClickOutside } from '@/shared/lib';
import { useAuthStore } from '@/store/authStore';
export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderLoyaltyButton',
  props: {
    isShowMobile: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    defineComponent({
      name: 'HeaderLoyaltyButton'
    });
    var tooltipOptions = computed(function () {
      return {
        theme: 'white',
        width: 'auto',
        padding: '0',
        rounding: 'xs',
        position: 'bottom',
        x: -180,
        y: 40
      };
    });
    var authStore = useAuthStore();
    var _storeToRefs = storeToRefs(authStore),
      isShowLoyaltyDayDowngradeStatus = _storeToRefs.isShowLoyaltyDayDowngradeStatus;
    var downgradeContentOpen = ref(false);
    var rootRef = ref(null);
    useClickOutside(rootRef, function () {
      downgradeContentOpen.value = false;
    });
    var _toRefs = toRefs(useScreenPlugin()),
      isDesktop = _toRefs.isDesktop;
    function handlerCloseContent() {
      if (isDesktop.value && isShowLoyaltyDayDowngradeStatus.value) {
        downgradeContentOpen.value = false;
      }
    }
    function handlerOpenContent() {
      if (isDesktop.value && isShowLoyaltyDayDowngradeStatus.value) {
        downgradeContentOpen.value = true;
      }
    }
    return {
      __sfc: true,
      tooltipOptions: tooltipOptions,
      authStore: authStore,
      isShowLoyaltyDayDowngradeStatus: isShowLoyaltyDayDowngradeStatus,
      downgradeContentOpen: downgradeContentOpen,
      rootRef: rootRef,
      isDesktop: isDesktop,
      handlerCloseContent: handlerCloseContent,
      handlerOpenContent: handlerOpenContent,
      SIcon: SIcon,
      STooltip: STooltip,
      DowngradeLoyaltyStatus: DowngradeLoyaltyStatus,
      LoyaltyButton: LoyaltyButton
    };
  }
});